module.exports = __webpack_public_path__ + "assets/img/404_qq.959ee803.svg";